<pg-manifest>
  <object class="circles circle-left" type="image/svg+xml" data={circles}></object>
  <object class="circles circle-left circle-green" type="image/svg+xml" data={circlesGreen}></object>
  <object class="circles circle-right" type="image/svg+xml" data={circles}></object>

  <section id="pg-manifest-first-section">
    <div id="main-logo">
      <a href="#/"><logo/></a>
    </div>

    <div class="main-content">
      <header>
        <h1>Manifesto</h1>
      </header>

      <main>
        <p>
          O mundo está cheio de oportunidades.
        </p>
        <p>
          Pessoas serão sempre a principal força à frente da inovação capaz de melhorar nossas relações.
        </p>
        <p>
          E é em <b>pessoas</b> que investimos.
        </p>
        <p>
          Negócios se interligam quando pessoas estão <b>interligadas</b>.
        </p>
        <p>
          Investimos em negócios <b>promissores</b>, em estágio inicial.
        </p>
        <p>
          Empresas com boas teses e que possuam necessidade de capital financeiro e estratégico para o crescimento dos seus negócios.
        </p>
        <p>
          Temos como principais pilares: os <b>valores</b>, a <b>lealdade</b>, a <b>garra</b> e a <b>inovação</b> dos envolvidos nos negócios.
        </p>
        <p>
          Quando encontramos pessoas boas com bons negócios, isso nos motiva a querer participar e impulsionar o business.
        </p>
      </main>
    </div>

    <div class="phrase">
      <logo onlyMark={true}/>
      <div class="content">
        <logo onlyText={true}/>
        <p>
          Criando <u>Valor</u>, <br>
          com <u>Lealdade</u>,<br>
          <u>Garra</u> e <u>Inovação</u>.
        </p>
      </div>
    </div>

    <div id="rights">
      <span>Grupo Sozo 	&#169; 2021</span>
      <span>Todos os direitos reservados</span>
    </div>
  </section>


  <script>
    import './pg-manifest.scss'

    import Logo from '../components/logo.riot'

    import circles from '../media/circles.svg'
    import circlesGreen from '../media/circles-green.svg'

    export default {
      circles, circlesGreen,
      state: {
        internalState: 'hi'
      },
      components: {
        Logo
      },
      onBeforeMount () {
        console.log('[home] mouting')

        // Change internal component state
        setTimeout(()=> {
          this.update({
            internalState: 'i change my value'
          })
        }, 1000)

        // Change application state (this not notify other components, you can implement an observer to that )
        setTimeout(()=> {
          this.actions.actionExample({something: 'i change too'})
          this.update()
        }, 2000)
      },
      onBeforeUpdate() {
        console.log('[home] updating')
      }
    }
  </script>
</pg-manifest>
